/* eslint-disable */
import { Select, Table, DatePicker,  Col, Row, Space } from "antd";
import React, { forwardRef, useEffect, useState } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import "./component/index.css";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const Main = forwardRef(() => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // 筛选后的数据
  const [reportList, setReportList] = useState([]);
  const [options, setOptions] = useState([]);
  const [tableoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [dateRange, setDateRange] = useState(null);
 const [timeDate, setTimeDate] = useState(null);
 



const handleCompleteRequestCountClick = (record) => {
  if (record.completeRequestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.completeRequestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/MaintenanceHistory";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

 
const handleOverCompleteRequestCountClick = (record) => {
  if (record.overCompleteRequestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.overCompleteRequestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/MaintenanceHistory";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const handleOverUncompleteRequestCountClick = (record) => {
  if (record.overUncompleteRequestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.overUncompleteRequestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/Maintenance";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const handleUncompleteRequestCountClick = (record) => {
  if (record.uncompleteRequestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.uncompleteRequestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/Maintenance";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};


const handlOverRequestCountClick = (record) => {
  if (record.overRequestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.overRequestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/Maintenance";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const handlRequestCountClick  = (record) => {
  if (record.requestCount === 0) {
    return;
  }
  console.log("Requests,", record);
  const params = { ids: record.requestIds };
  const baseUrl = window.location.origin;
  const route = "/JobRequests/Maintenance";
  const paramString = new URLSearchParams(params).toString();
  const hash = `${route}${paramString ? `?${paramString}` : ""}`;
  const url = `${baseUrl}#${hash}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

  const handleDateChange = (dates, dateStrings) => {

   fetchData(dateStrings[0], dateStrings[1]);
  };

 
  const onTypeChange = (value, option) => {
    console.log(option);
  };

  const stepSearchChange = (value) => {
    setReportList(value);
  };

  const initColumns = [
    {
      title: "Supervisor Name",
      dataIndex: "supervisorName",
      key: "supervisorName",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text) => text,
    },
    {
      title: "Requests",
      dataIndex: "requestCount",
      key: "requestCount",
      hidden: false,
      width: 300,
      align: "center",
                render: (text, record) => (
    <span 
      style={{ 
        color: '#0e78a9', 
        textDecoration: 'underline',
        cursor: 'pointer' 
      }}
      onClick={() => handlRequestCountClick(record)} 
    >
      {text}
    </span>
  ),
    },
    {
      title: "Overdue Requests",
      dataIndex: "overRequestCount",
      key: "overRequestCount",
      hidden: false,
      width: 300,
      align: "center",
             render: (text, record) => (
    <span 
      style={{ 
        color: '#0e78a9', 
        textDecoration: 'underline',
        cursor: 'pointer' 
      }}
      onClick={() => handlOverRequestCountClick(record)} 
    >
      {text}
    </span>
  ),
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 初始化函数 -

  useEffect(() => {
    fetchData();
  }, []);

  //列表
  const fetchData = async (startTime, endTime) => {
    
    try {
   const timestamps = getCurrentMonthRange(startTime, endTime); 
    console.log("时间范围:", timestamps); 
    setTimeDate(timestamps);
      // console.log("=====请求数据======");
           const params = {
        sCreateTime: timestamps.startTime || "",
        eCreateTime:timestamps.endTime || "",
      }
      const response = await http.get(`${api.getReportList}`, { params });

      const dataWithKey = (response.data || [])?.map((item) => ({
        ...item,
        key: item.accountId,
      }));
      console.log("response", dataWithKey);
      setFilteredData(dataWithKey);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  // 处理分页变化
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("页码更新");
    console.log(filters);
    //table筛选
    console.log("Sorter:", sorter); //可选值为 ['ascend'升序, 'descend'降序, undefined未选中] 或自定义顺序。
    console.log(pagination);
    fetchData();
  };

    
  // 时间戳转化
  const getCurrentMonthRange = (startTime, endTime) => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0"); // 补零
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const toTimestamp = (dateString) => {
      return new Date(dateString).getTime();
    };
    return {
      startTime: toTimestamp(formatDate(new Date(startTime))),
      endTime: toTimestamp(formatDate(new Date(endTime))),
    };
  };


  return (
    <div>
      <Row>
        <Col span={6}>
          <div className="content">
            <h3>Report:</h3>
            <Select
              showSearch
              allowClear
              placeholder="Select a report"
              onChange={onTypeChange}
              onSearch={stepSearchChange}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={reportList}
              style={{ width: 400, marginLeft: 20 }}
            />
          </div>
        </Col>
        <Col span={18}>
          {/* <RangePicker onChange={handleDateChange} format="YYYY-MM-DD" /> */}
          <div style={{ marginTop: "20px" }}>
     <Table
            rowClassName="table-row-gradient"
            loading={tableoading}
            bordered={true} 
            columns={columns.filter((col) => col.hidden === false)}
            dataSource={[...filteredData]}
            rowKey="accountId" // 唯一标识
            onChange={handleTableChange} // 分页、排序、筛选变化时触发
            scroll={{
              x: "max-content", //横向滚动宽度
              y: "calc(100vh - 350px)", //纵向滚动高度
            }}
            className="my-Table"
          />
          </div>
      
        </Col>
      </Row>
    </div>
  );
});
export default Main;
